import PropTypes from "prop-types";

export default PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    agentLink: PropTypes.string,
    company: PropTypes.string,
    activeSince: PropTypes.string,
    avatar: PropTypes.string,
    starRatingPercent: PropTypes.number,
  })
);
